import $x from '@/utils/$x';

// 查询专题列表
export async function getXplanTopicList(params) {
  return $x.post('/xplantopic/getXplanTopicList', params);
}

// 查询专题详情
export async function getXplanTopicDetail(params) {
  return $x.post('/xplantopic/getXplanTopicDetail', params);
}

// 新增xplan专题
export async function addXplanTopicDetail(params) {
  return $x.post('/xplantopic/addXplanTopic', params);
}

// 更新xplan专题
export async function updateXplanTopic(params) {
  return $x.post('/xplantopic/updateXplanTopic', params);
}

// 删除专题
export async function delXplanTopic(params) {
  return $x.post('/xplantopic/delXplanTopic', params);
}

// 渠道列表
export async function getChannelList(params) {
  return $x.post('/contentChannel/getChannelCategoryRelPage', params);
}

// 查询一般课程列表
export async function getXplanContentPage(params) {
  return $x.post('/xplancontent/getXplanContentPage', params);
}